<div class="c-modal c-modal--md" id="modal-{{vm.uid}}">
    <div mat-dialog-content class="c-modal__dialog">
        <div class="c-modal__header">
            <div class="o-grid o-grid--center-h">
                <div class="o-grid__cell o-grid__cell--center-h">
                    <p style="font-size: 22px">{{ 'Modal.Profile.Authentication.Totp_Authentication_Title' | translate }}</p>
                </div>
                <div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
                    <button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
                        <i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
                        <span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-modal__content u-no-pt">
            <div class="c-card c-card--height-fit" style="box-shadow: none;" *ngIf="!vm.showInstruction  && !vm.isVerificationSuccess">
                <div *ngIf="vm.qrCodeImage" class="o-grid o-grid--center-h">
                    <p class="c-text" style="margin-top: 20px;">{{ 'Modal.Profile.Authentication.Totp_Authentication_Description' | translate }}</p>
                </div>
                <div *ngIf="vm.qrCodeImage" class="o-grid o-grid--center-h">
                    <img [src]="vm.qrCodeImage" alt="Authenticator QR Code" class="qr-code-img">
                </div>
                <div class="c-form__group" style="margin-top: 25px" [ngClass]="{ 'c-form__group--error': vm.submitted && verificationCode.invalid }">
                    <label class="c-form__label">{{ 'Modal.Profile.Authentication.Totp_Authentication_Label' | translate }}</label>
                    <input name="verificationCode"  #verificationCode="ngModel" type="number"  class="c-form__input c-form__input--sm" [(ngModel)]="vm.verificationCode" maxlength="6" required>
                    <item-form-error-with-translator *ngIf="vm.submitted && verificationCode.invalid" [fieldName]="'Login.Verification_Code' | translate" [error]="verificationCode.errors"></item-form-error-with-translator>
                    <p class="c-text c-text--s3 c-text--center u-osb-lg" id="st-error-wrong-verification-code" style="margin-top: 10px" *ngIf="vm.showWrongVerificationError">{{ "Login.Wrong_Verification_Code" | translate }}</p>
                    <button style="margin-top: 18px"
                            id="submitVerificationCode"
                            (click)="vm.submit()"
                            type="button"
                            class="c-button c-button--s1 c-form__center-button">
                        {{ 'Modal.Profile.Authentication.Verify_Button' | translate }}
                    </button>
                </div>
                <loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
            </div>
            <div class="c-card c-card--height-fit" style="box-shadow: none;" *ngIf="!vm.showInstruction && vm.isVerificationSuccess">
                <div class="o-grid o-grid--center-h" style="margin-top: 18px">
                    <p class="c-text">{{ 'Modal.Profile.Authentication.Enable_Totp_Auth_Info' | translate }}</p>
                </div>
                <div class="o-grid o-grid--center-h">
                    <button style="margin-top: 18px"
                            id="closeDialogButton"
                            (click)="vm.close()"
                            type="button"
                            class="c-button c-button--s1">
                        {{ 'Modal.Button.Close' | translate }}
                    </button>
                </div>
            </div>
            <div class="c-card c-card--height-fit" style="box-shadow: none; margin-top: 20px;" *ngIf="vm.showInstruction">
                <div class="o-grid o-grid--center-h">
                   <p class="c-text">{{ 'Modal.Profile.Authentication.Totp_Authentication_Instruction' | translate }}</p>
                </div>
                <div class="c-form__group u-osb-lg" style="margin-top: 20px;">
                    <label for="app-" class="c-form__label">{{ 'Modal.Profile.Authentication.Totp_Authentication_Choose_App' | translate }}</label>
                    <mat-select id="app-" name="app" (selectionChange)="vm.onAppSelectionChange($event.value)" [(value)]="vm.totpApp" class="mat-select mat-select--sm mat-select--border">
                        <mat-option *ngFor="let app of vm.apps" [value]="app.value">
                            {{ app.label }}
                        </mat-option>
                    </mat-select>
                </div>

                <div class="o-grid o-grid--center-v o-grid--center-h" *ngIf="vm.appLogoLang && vm.isGoogleAuthenticator" style="margin-top: 10px;">
                    <div style="padding-left:0px !important;" class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
                        <a href="{{vm.googleIosLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/app-store-en.png" alt="App Store">
                        </a>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
                        <a href="{{vm.googleAndroidLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/google-play-en.png" alt="Google Play"></a>
                    </div>
                </div>
                <div class="o-grid o-grid--center-v o-grid--center-h" *ngIf="vm.appLogoLang && vm.isApplePasswordManager" style="margin-top: 10px;">
                    <div style="padding-left:0px !important;" class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
                        <p class="c-text">{{ 'Modal.Profile.Authentication.Totp_Apple_Password_Manager_Info' | translate }}</p>
                    </div>
                </div>
                <div class="o-grid o-grid--center-v o-grid--center-h" *ngIf="vm.appLogoLang && vm.isMsAuthenticator" style="margin-top: 10px;">
                    <div style="padding-left:0px !important;" class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
                        <a href="{{vm.msIosLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/app-store-en.png" alt="App Store">
                        </a>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
                        <a href="{{vm.msAndroidLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/google-play-en.png" alt="Google Play"></a>
                    </div>
                </div>
                <div class="o-grid o-grid--center-v o-grid--center-h">
                    <button style="margin-top: 24px"
                            id="proceedButton"
                            (click)="vm.handleInstructionView()"
                            type="button"
                            class="c-button c-button--s1">
                        {{ 'Modal.Profile.Authentication.Proceed_Button' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
